import React from "react";
import { Tag } from "antd";

const SESSION_STATUS_CONFIG = {
  completed: { label: "Completed", color: "green" },
  in_progress: { label: "In Progress", color: "gold" },
};

const getStatusConfig = (status) => {
  if (SESSION_STATUS_CONFIG[status]) return SESSION_STATUS_CONFIG[status];
  const label = status
    ? status.replaceAll("_", " ").replace(/\b\w/g, (char) => char.toUpperCase())
    : "Unknown";
  return { label, color: "default" };
};

const SESSION_TYPE_CONFIG = {
  cohort: { label: "Cohort", color: "blue" },
  individual: { label: "Individual", color: "purple" },
};

const getSessionTypeConfig = (isCohortSession) =>
  isCohortSession ? SESSION_TYPE_CONFIG.cohort : SESSION_TYPE_CONFIG.individual;

export const StatusTag = ({ status, className = "" }) => {
  const { label, color } = getStatusConfig(status);
  return (
    <Tag color={color} className={`!text-xs ${className}`}>
      {label}
    </Tag>
  );
};

export const SessionTypeTag = ({ isCohortSession, className = "" }) => {
  const { label, color } = getSessionTypeConfig(isCohortSession);
  return (
    <Tag color={color} className={`!text-xs ${className}`}>
      {label}
    </Tag>
  );
};